module.exports = __webpack_public_path__ + "assets/webgl/card_080_DE_L0.jpg.48364318.webp";